"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CheckboxInput.default;
  }
});

var _CheckboxInput = _interopRequireDefault(require("./CheckboxInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }